'use strict';

global.utl = require('./utils.js');
global.cookieManager = require('./cookieManager.js');
global.cookiebar = require('./cookiebar.js');

jQuery(function($) {

    initFormContacts();
    initFormSatellite();

    // Filetto Tabella
    function isEmpty( el ){
        return !$.trim(el.html())
    }
    if (! isEmpty($('.template-press tr td:nth-of-type(2)'))) {
        $('.template-press tr td:nth-of-type(2)').addClass('template-press__separators');
    } else {
    }

});

// hcaptcha

function onHCaptchaError()
{
    alert('Ops! Si è verificato un errore...');
}
global.onHCaptchaError = onHCaptchaError;

// contact

function onContactSubmit()
{
    console.log('onHCaptchaContactClose');

    if (typeof hcaptcha == 'undefined') {
        onHCaptchaError();
    } else {
        document.getElementById('contact-submit').classList.add('hidden');
        document.getElementById('contact-loader').classList.remove('hidden');
        hcaptcha.execute(hcaptcha.render('h-captcha-contact-form', {
            sitekey: hcaptcha_key,
        }));
    }
}
global.onContactSubmit = onContactSubmit;

function onHCaptchaContactClose()
{
    console.log('onHCaptchaContactClose');
    document.getElementById('contact-submit').classList.remove('hidden');
    document.getElementById('contact-loader').classList.add('hidden');
}
global.onHCaptchaContactClose = onHCaptchaContactClose;

function onHCaptchaContactCallback(token)
{
    var form = $('#form_contatti');

    $.post('/contact/send', form.serializeArray(), function(data) {
        setTimeout(function () {
            $('#form-contatti-wrapper').html(data.html);

            setTimeout(function (args) {
                initFormContacts();
            }, 250);
        }, 250);
        if (data.result) {
            dataLayer.push({
                'event': 'submit',
                'context_submitted': 'Contact__contact'
            });

            utl.fbq_trackCustom('Contact__submit');
        }
        if (data.newsletter) {
            dataLayer.push({
                'event': 'submit',
                'context_submitted': 'Contact__newsletter_submit'
            });
            utl.fbq_trackCustom('Contact__newsletter_submit');
        }
    });
}
global.onHCaptchaContactCallback = onHCaptchaContactCallback;

function initFormContacts() {
    if (document.getElementById('form_contatti')) {
        document.getElementById('contact-submit').classList.remove('hidden');
        document.getElementById('contact-loader').classList.add('hidden');
    }
}
global.initFormContacts = initFormContacts;


// satellite

function onSatelliteSubmit()
{
    console.log('onHCaptchaSatelliteClose');
    if (typeof hcaptcha == 'undefined') {
        onHCaptchaError();
    } else {
        document.getElementById('satellite-submit').classList.add('hidden');
        document.getElementById('satellite-loader').classList.remove('hidden');
        hcaptcha.execute(hcaptcha.render('h-captcha-satellite-form', {
            sitekey: hcaptcha_key,
        }));
    }
}
global.onSatelliteSubmit = onSatelliteSubmit;

function onHCaptchaSatelliteClose()
{
    console.log('onHCaptchaSatelliteClose');
    document.getElementById('satellite-submit').classList.remove('hidden');
    document.getElementById('satellite-loader').classList.add('hidden');
}
global.onHCaptchaSatelliteClose = onHCaptchaSatelliteClose;

function onHCaptchaSatelliteCallback(token)
{
    var form = $('#form_satellite');

    var url = form.attr('action');

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        beforeSend: function() {

            $('.form_theme_satellite').addClass('hidden');
            $('.form__message_type_loading[data-form="satellite"]').removeClass('hidden');
        },
        complete: function() {

            $('.form__message_type_loading[data-form="satellite"]').addClass('hidden');

            initFormSatellite();
        }
    }).done(function (data) {

        $('.form__message_type_success[data-form="satellite"]').removeClass('hidden');

        if (data.result == 'SENT') {

            $('.form__message_type_error[data-form="satellite"]').addClass('hidden');

            dataLayer.push({
                'event': 'submit',
                'context_submitted': 'NewProject__submit'
            });
            utl.fbq_trackCustom('New_Project__submit');
        }

        initFormSatellite();

    }).fail(function (data) {

        $('.form__message_type_error[data-form="satellite"]').removeClass('hidden');
        $('.form_theme_satellite').removeClass('hidden');

        initFormSatellite();

    });
}
global.onHCaptchaSatelliteCallback = onHCaptchaSatelliteCallback;

function initFormSatellite() {
    if (document.getElementById('form_satellite')) {
        document.getElementById('satellite-submit').classList.remove('hidden');
        document.getElementById('satellite-loader').classList.add('hidden');
    }
}
global.initFormSatellite = initFormSatellite;


// Newsletter

function onNewsletterSubmit(isPowwow) {
    if (isPowwow) {
        global.newsletterScope = '-powwow';
    } else {
        global.newsletterScope = '';
    }

    var error = 0;
    var form = $('#newsletter-form' + global.newsletterScope);

    if(!utl.validateEmail(form.find('input[name="newsletter' + global.newsletterScope + '[email]"]').val())) {
        error = 1;

        document.querySelector("[data-js='newsletter" + global.newsletterScope + "-message-type-error']").classList.remove("hidden");

        initFormNewsletter();
    } else {

        document.querySelector("[data-js='newsletter" + global.newsletterScope + "-message-type-error']").classList.add("hidden");
        // start captcha

        console.log('onHCaptchaNewsletterClose');

        if (typeof hcaptcha == 'undefined') {
            onHCaptchaError();
        } else {
            document.querySelector("[data-js='newsletter" + global.newsletterScope + "-submit']").classList.add("hidden");
            document.querySelector("[data-js='newsletter" + global.newsletterScope + "-loader']").classList.remove("hidden");
            
            hcaptcha.execute(hcaptcha.render('h-captcha-newsletter' + global.newsletterScope + '-form', {
                sitekey: hcaptcha_key,
            }));
        }
    }
}

global.onNewsletterSubmit = onNewsletterSubmit;

function onHCaptchaNewsletterClose() {
    console.log('onHCaptchaNewsletterClose');

    document.querySelector("[data-js='newsletter" + global.newsletterScope + "-submit']").classList.remove("hidden");
    document.querySelector("[data-js='newsletter" + global.newsletterScope + "-loader']").classList.add("hidden");
}

global.onHCaptchaNewsletterClose = onHCaptchaNewsletterClose;

function onHCaptchaNewsletterCallback(token) {
    var form = $('#newsletter-form' + global.newsletterScope);

    var url = form.attr('action') + (global.newsletterScope ? '?powwow=true' : '');

    $.ajax({
        type: "POST",
        url: url,
        data: form.serialize(),
        beforeSend: function () {
            $('.newsletter' + global.newsletterScope + '__form').addClass('hidden');
            
            document.querySelector("[data-js='newsletter" + global.newsletterScope + "-message-type-loading']").classList.remove("hidden");
        },
        complete: function () {
            document.querySelector("[data-js='newsletter" + global.newsletterScope + "-message-type-loading']").classList.add("hidden");
        }
    }).done(function(data) {

        document.querySelector("[data-js='newsletter" + global.newsletterScope + "-message-type-success']").classList.remove("hidden");

        var campaign = (form.attr('data-campaign') ? form.attr('data-campaign') : 'Powwow');

        if (typeof trackCampaignPrefix != 'undefined') {
            campaign = trackCampaignPrefix + ' - ' + campaign;
        }

        dataLayer.push({
            'event': 'submit',
            'context_submitted': campaign + '__newsletter_submit'
        });

        utl.fbq_trackCustom(campaign.replaceAll(' ', '_') + '__newsletter_submit');

    }).fail(function(data) {

        document.querySelector("[data-js='newsletter" + global.newsletterScope + "-message-type-error']").classList.remove("hidden");

        $('.newsletter' + global.newsletterScope + '__form').removeClass('hidden');

    });

    initFormNewsletter();
}

global.onHCaptchaNewsletterCallback = onHCaptchaNewsletterCallback;

function initFormNewsletter() {

    if (document.querySelector("[data-js='newsletter" + global.newsletterScope + "-submit']")) {
        document.querySelector("[data-js='newsletter" + global.newsletterScope + "-submit']").classList.remove("hidden");
    }

    if (document.querySelector("[data-js='newsletter" + global.newsletterScope + "-loader']")) {
        document.querySelector("[data-js='newsletter" + global.newsletterScope + "-loader']").classList.add("hidden");
    }
}

global.initFormNewsletter = initFormNewsletter;